__turbopack_context__.v({
  "container": "CartDrawer-module-scss-module__rWmdwW__container",
  "isOpen": "CartDrawer-module-scss-module__rWmdwW__isOpen",
});
